<template>
  <div class="client-search-wrapper h-48">
    <vue-bootstrap-typeahead
      v-model="value"
      :data="results"
      :serializer="item => `${item.ClientID} : ${item.ClientName}`"
      @hit="chosen = $event.ClientID; chosenFull = $event"
      placeholder="Search by Dynad Id or Name"
    />
    <span class="client-search-spinner" v-if="inProgress">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
  </div>

</template>
<script>
  import {debounce} from 'lodash'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  export default{
    props:{
      searchUrl: String
    },
    data(){
      return {
        value: '',
        results: [],
        chosen: null,
        chosenFull: null,
        inProgress: false,
      }
    },
    methods:{
      async searchClients(){
        // Vue typeahead calls this again of choose of item from dropdown,
        // emit chosen
        // return early to avoid search again
        if(this.value.startsWith(this.chosen)) {
          this.$dispatch('input', this.chosenFull)
          return
        }
        this.$dispatch('searching');
        this.inProgress = true
        const results = await axios.get(`${this.searchUrl}?q=${this.value}`)
        this.results = results.data.companies
        this.inProgress = false
        this.$dispatch('done', this.results)
      },
    },
    watch:{
      value:{
        handler: debounce(function(){ //must be old style function declaration for this to retain proper reference
          this.searchClients()
        }, 500)
      }
    }
  }
</script>
<style scoped lang="scss">
  .client-search-wrapper{
    position:relative;
    .client-search-spinner{
      z-index: 4;
      position:absolute;
      top:50%;
      transform:translateY(-50%);
      right:12px;
      background:white;
    }
  }
</style>
